class Caret {
  constructor(target) {
    this.isContentEditable = target && target.contentEditable;
    this.target = target;
  }

  getPos() {
    // for contentedit field
    if (this.isContentEditable) {
      this.target.focus();
      let _range = document.getSelection().getRangeAt(0);
      let range = _range.cloneRange();
      range.selectNodeContents(this.target);
      range.setEnd(_range.endContainer, _range.endOffset);
      return range.toString().length;
    }
    // for texterea/input element
    return this.target.selectionStart;
  }

  setPos(pos) {
    // for contentedit field

    if (this.isContentEditable) {
      this.target.focus();
      document.getSelection().collapse(this.target, pos);
      return;
    }
    this.target.setSelectionRange(pos, pos);
  }
}

function StreamEditorController(stateService, CommonService, toasterService, $timeout, $sce) {
  const ctrl = this;
  const swap = CommonService.swap;
  const getAudioSegment = CommonService.getAudioSegment;
  const preLoadAudio = CommonService.preLoadAudio;
  const preLoadStream = CommonService.preLoadStream;
  const getMacroList = CommonService.getMacroList;
  const checkName = CommonService.checkName;

  ctrl.$onInit = async () => {
    if (!ctrl.selection) {
      ctrl.stream = {
        name: null,
        description: null,
        fragments: [],
        types: [],
      };
      ctrl.newStream = true;
      ctrl.viewMode = false;
      ctrl.audioType = false;
      ctrl.textType = false;
      ctrl.synchronize_types = false;
    } else {
      // Storing fragments to a variable before Angular.copy.
      ctrl.originalFragments = [];
      _.each(ctrl.selection.fragments, f => {
        ctrl.originalFragments.push(f);
      })
      ctrl.stream = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
      parseTypes(ctrl.stream);
    }
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    ctrl.loadVariables(ctrl.workspaceId);
    ctrl.existingFragments = await stateService.getFragments(ctrl.workspaceId);

    // resolve the "ignore last audio" for the last fragment of this stream
    const foundStream = ctrl.streams.find(({ id }) => id === ctrl.stream.id);
    if (foundStream && foundStream.fragments && foundStream.fragments.length > 1) {
      let lastFragment = foundStream.fragments.pop();
      ctrl.ignoreLastAudio = lastFragment.ignore_me;
    }

    if (ctrl.originalFragments) {
      ctrl.loadingFragments = true;
      let fragmentPromises = [];
      ctrl.originalFragments.forEach(function(fragment) {
        // No requests needed for macro fragments
        if (fragment.id && fragment.id !== -1) {
          fragmentPromises.push(stateService.getFragment(ctrl.workspaceId, fragment.id));
        }
      });

      // Combine the promise results and original fragments to make an indexed fragment list
      Promise.all(fragmentPromises).then(response => { 
        ctrl.originalFragments.forEach(function(originalFragment, index) { 
          let fragment;
          if (originalFragment.id !== -1) {
            fragment = response.find(({ id }) => id === originalFragment.id);
          } else {
            fragment = originalFragment;
          }
          ctrl.stream.fragments[index] = fragment;
      });
      calcPos(ctrl.stream.fragments);
     });
    }
    if (ctrl.selection) {
      const macroList = await getMacroList(ctrl.workspaceId);
      ctrl.streamFileUrl = await preLoadStream(ctrl.workspaceId, ctrl.stream, macroList);
    }
    ctrl.resultFragments = [];
    ctrl.sentenceInput = '';
    ctrl.macroMismatch = ctrl.stream.macro_stream_target !== ctrl.stream.macro_stream_match;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.stream = angular.copy(ctrl.selection);
      searchFragmentNames(ctrl.stream.fragments, ctrl.existingFragments);
      calcPos(ctrl.stream.fragments);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkDuplicate = () => {
    ctrl.duplicateName = checkName(ctrl.streams, ctrl.stream);
  };

  ctrl.loadVariables = id => {
    stateService.getVariables(id).then(data => {
      ctrl.variables = data;
    });
  };

  ctrl.checkValidity = () => {
    return !!(!ctrl.audioType && !ctrl.textType) || ctrl.stream.fragments.length === 0 || ctrl.duplicateName;
  };
  
  ctrl.addMacroFragment = () => {
    let fragment = {
      text: ctrl.macroFragment,
      name: ctrl.macroFragment,
    };
    ctrl.stream.fragments.push(fragment);
    calcPos(ctrl.stream.fragments);
  };

  const searchFragmentNames = (streamFrags, allFrags) => {
    _.each(streamFrags, frag => {
      let found = allFrags.find(item => item.id === frag.id);
      if (found) {
        frag.name = found.name;
        frag.files = found.files;
      } else if (frag.macro_fragment) {
        frag.name = frag.macro_fragment;
      }
    });
  };

  ctrl.trustedHtmlFilter = htmlContent => $sce.trustAsHtml(htmlContent);

  let delay = null;
  let handledWords = [];
  let lockedWordIndex = 0;
  let words = [];

  ctrl.handleSentence = $event => {
    $event.preventDefault();
    $event.stopPropagation();
    let content = $event.target.innerHTML
      .toString()
      .replace(/<br>/g, '')
      .replace(/(<([^>]+)>)/gi, '');

    if (content.length === 0) {
      ctrl.resultFragments = [];
      return false;
    }
    if (content.length < 2) {
      return false;
    }
    clearTimeout(delay);
    delay = setTimeout(() => {
      words = content
        .trim()
        .split(/\s+/)
        .map(word => word.trim().replace(/\./g, ''));
      ctrl.resultFragments = [];
      let cursorWord = words[lockedWordIndex];
      _.each(words, cursorWord => {
        if (cursorWord.length > 1) {
          ctrl.existingFragments.forEach(fragment => {
            if (fragment.name.toLowerCase().search(cursorWord.toLowerCase()) > -1) {
              if (!ctrl.resultFragments.includes(fragment)) {
                ctrl.resultFragments.push(fragment);
              }
            }
          });
          // if (ctrl.resultFragments.length > 0) {
          //   modifySentenceInput(words, lockedWordIndex);
          // }
        } else {
          // Don't search for single character words
          // clearTimeout(delay);
          // return false;
        }
      });
    }, 500);
  };

  ctrl.preventEnter = $event => {
    if ($event.keyCode === 13) {
      $event.preventDefault();
      $event.stopPropagation();
      return false;
    }
  };

  ctrl.removeFragment = index => {
    ctrl.calcDone = false;
    _.each(ctrl.stream.fragments, f => {
      f.audio = null;
    });
    ctrl.stream.fragments.splice(index, 1);
    // CALCULATE POSITION DATA FOR EACH FRAGMENT
    calcPos(ctrl.stream.fragments);
  };

  ctrl.move = (slot1, slot2) => {
    ctrl.calcDone = false;
    _.each(ctrl.stream.fragments, f => {
      f.audio = null;
    });
    ctrl.stream.fragments = swap(angular.copy(ctrl.stream.fragments), slot1, slot2);
    // CALCULATE POSITION DATA FOR EACH FRAGMENT
    calcPos(ctrl.stream.fragments);
  };

  ctrl.onSubmit = () => {
    // eliminate the fragments with negative id from the request payload
    let fragmentsToSubmit = [];
      _.each(ctrl.stream.fragments, f => {
        if (f.id === -1) {
          fragmentsToSubmit.push({text: f.macro_fragment, name: f.macro_fragment, ignore_me: f.ignore_me});
        } else {
          fragmentsToSubmit.push(f);
        }
    });
    let streamObject = {
      name: ctrl.stream.name,
      description: ctrl.stream.description,
      types: buildTypeObjects(),
      fragments: fragmentsToSubmit.map(f => {
        if (f.id && f.id !== -1) {
          return { id: f.id, ignore_me: f.ignore_me };
        } else if (!f.id || f.id === -1) {
          return { macro_fragment: f.text, id: -1 };
        }
      }),
      send_to_train_anyway: false,
      same_actor: false,
      synchronize_types: (ctrl.audioType && ctrl.textType ? ctrl.synchronize_types : false),
      macro_stream_target: ctrl.stream.macro_stream_target
    };

    if (ctrl.stream.id >= 0) {
      // OLD STREAM EDIT
      stateService.editStream(ctrl.workspaceId, ctrl.stream.id, streamObject).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-stream-successful');
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-stream-failure');
          console.error(e);
        }
      );
    } else {
      // NEW STREAM
      stateService.createStream(streamObject, ctrl.workspaceId).then(
        function (response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-new-stream-successful');
        },
        function (e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-new-stream-failure');
          console.error(e);
        }
      );
    }
  };

  const parseTypes = stream => {
    _.each(stream.types, type => {
      if (type.name === 'AUDIO') {
        ctrl.audioType = true;
        if (type.override) {
          ctrl.audioOverride = true;
        }
      } else if (type.name === 'TEXT') {
        ctrl.textType = true;
        if (type.override) {
          ctrl.textOverride = true;
        }
      }
    });
    ctrl.synchronize_types = stream.synchronize_types;
  };

  const buildTypeObjects = () => {
    let list = [];
    if (ctrl.audioType && ctrl.audioOverride) {
      list.push({ name: 'AUDIO', override: true });
    } else if (ctrl.audioType && !ctrl.audioOverride) {
      list.push({ name: 'AUDIO', override: false });
    }
    if (ctrl.textType && ctrl.textOverride) {
      list.push({ name: 'TEXT', override: true });
    } else if (ctrl.textType && !ctrl.textOverride) {
      list.push({ name: 'TEXT', override: false });
    }
    return list;
  };

  const modifySentenceInput = (words, lockedIndex) => {
    let totalLength = 0;
    let modifiedString = '';
    words.forEach((word, index) => {
      if (index === lockedIndex) {
        modifiedString += '<span style="background-color: #66b3ff;">' + word + '</span> ';
      } else {
        modifiedString += word + ' ';
      }
    });

    //let caret = new Caret(document.querySelector('#announcement-input'));
    //let previousPos = caret.getPos();

    ctrl.sentenceInput = modifiedString;

    let elem = document.querySelector('#announcement-input');
    elem.focus();

    //caret.setPos(previousPos);
  };

  const calcPos = fragments => {
    if (!fragments) return;
    if (fragments.length === 1) {
      fragments[0].position = 'INDEPENDENT';
    } else if (fragments.length === 2) {
      fragments[0].position = 'BEGIN';
      fragments[1].position = 'END';
    } else if (fragments.length > 2) {
      fragments[0].position = 'BEGIN';
      for (let i = 1; i < fragments.length - 1; ++i) {
        fragments[i].position = 'MIDDLE';
      }
      _.last(fragments).position = 'END';
    }
    _.each(fragments, f => {

      if (f.id >= 0) {
        if (f.files) {
          let audioSegment = getAudioSegment(f.files);
          if (audioSegment) {
            f.filtered = preLoadAudio(audioSegment);
            if (f.filtered) {
              f.audio = f.filtered.find(({ audio_type }) => audio_type === f.position);
            }
          }
        }
      }
    });
    $timeout(() => {
      ctrl.calcDone = true;
      ctrl.loadingFragments = false;
    }, 300);
  };

  ctrl.clearForm = () => {
    ctrl.streamForm.$setPristine(true);
    ctrl.streamForm.$setUntouched(true);
    ctrl.viewMode = false;
    ctrl.duplicateName = false;
    ctrl.stream = {
      name: null,
      description: null,
      fragments: [],
      types: [],
    };
    ctrl.audioType = null;
    ctrl.audioOverride = null;
    ctrl.textType = null;
    ctrl.textOverride = null;
    ctrl.synchronize_types = null;
  };

  ctrl.toggleIgnoreLastAudio = () => {
    const lastFragmentIndex = ctrl.stream.fragments.length - 1;
    if (lastFragmentIndex < 0) return;
    ctrl.stream.fragments.forEach(function(f, index) { 
      if (index === lastFragmentIndex) {
        f.ignore_me = ctrl.ignoreLastAudio;    
      }
    });
  };

  ctrl.fragmentClickActions = async(fragment) => {
    _.remove(ctrl.resultFragments, { id: fragment.id });

    const existingFragment = await stateService.getFragment(ctrl.workspaceId, fragment.id);

    ctrl.stream.fragments.push(existingFragment);

    // CALCULATE POSITION DATA FOR EACH FRAGMENT
    calcPos(ctrl.stream.fragments);

    if (words.length > lockedWordIndex + 1) {
      handledWords.push({ index: lockedWordIndex, text: fragment.text });
      lockedWordIndex += fragment.text.trim().split(/\s+/).length;
    } else {
      lockedWordIndex = 0;
    }
  };
}

angular
  .module('pis-tool.module')
  .controller('StreamEditorController', StreamEditorController);
